// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RJ-z","twoColumnImage":"SJ-z"};